module.exports = __webpack_public_path__ + "fc8d3bb79cbd5f6920094eb4c4f1be01.MP3";